// Typelizer digest 861f3a2f39b21887fa7f8bc3b2080a20
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/documents/:document_id/counterparties */
  create: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/documents/:document_id/counterparties', params, options),
    method: 'post',
  }),

  /** PATCH /c/:company_id/documents/:document_id/counterparties/:id */
  update: (
    params: { documentId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/documents/:document_id/counterparties/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /c/:company_id/documents/:document_id/counterparties/:id */
  destroy: (
    params: { documentId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/documents/:document_id/counterparties/:id', params, options),
    method: 'delete',
  }),
}
